import type { Munkaido } from '@ertekbecslo/kozos/iroda';

const NAPOK: [string, string][] = [
  ['1', 'Hétfő'], ['2', 'Kedd'], ['3', 'Szerda'], ['4', 'Csütörtök'], ['5', 'Péntek'], ['6', 'Szombat'], ['7', 'Vasárnap'],
];
// Legalább 16px: az iOS Safari kisebb betűs mezőre fókuszáláskor ránagyít.
const MEZO = 'min-h-11 w-full min-w-0 rounded-xl border border-vonal bg-hatter-melyen px-2 text-[max(16px,1rem)] text-szoveg focus:border-kiemelt disabled:opacity-50';

export default function MunkaidoSzerkeszto({ ertek, onValtoztat }: { ertek: Munkaido; onValtoztat(m: Munkaido): void }) {
  const beallit = (nap: string, par: [string, string] | null) => {
    const uj = { ...ertek };
    if (par) uj[nap] = par; else delete uj[nap];
    onValtoztat(uj);
  };
  return (
    <fieldset className="grid gap-2">
      <legend className="mb-1 text-sm text-szoveg-halk">Munkaidő (amikor a „Hívjon most” gomb látszik)</legend>
      {NAPOK.map(([nap, cimke]) => {
        const par = ertek[nap];
        const hibas = par !== undefined && par[0] >= par[1];
        return (
          <div key={nap} className="grid grid-cols-2 items-center gap-2 sm:grid-cols-[6.5rem_minmax(0,1fr)_minmax(0,1fr)]">
            <label className="col-span-2 flex min-h-11 items-center gap-2 text-sm sm:col-span-1">
              <input type="checkbox" className="size-5 accent-kiemelt" checked={par !== undefined} onChange={(e) => beallit(nap, e.target.checked ? ['09:00', '17:00'] : null)} />
              {cimke}
            </label>
            <input type="time" aria-label={`${cimke} kezdete`} className={MEZO} disabled={!par} value={par?.[0] ?? ''} onChange={(e) => par && beallit(nap, [e.target.value, par[1]])} />
            <input type="time" aria-label={`${cimke} vége`} className={MEZO} disabled={!par} value={par?.[1] ?? ''} onChange={(e) => par && beallit(nap, [par[0], e.target.value])} />
            {hibas && <p className="col-span-2 text-sm text-hiba sm:col-span-3">A kezdetnek a vég előtt kell lennie; különben a nap kimarad a mentésből.</p>}
          </div>
        );
      })}
    </fieldset>
  );
}
